






































































































import { Vue, Component, Emit, Prop, PropSync } from 'vue-property-decorator';
import { Mall } from 'ncp-api-supporter';
import SelectBox from '@/pro/components/common/SelectBox.vue';
import ToolTip from '@/pro/components/common/tooltip/ToolTip.vue';
import {ExcelUploadType, ResultPopupData} from '@/pro/types/ProductThumbnailRegistration';
import {mall} from '@/pro/utils/mall';
import {validateFileNameExtension} from '@/pro/utils/webExcel';
import {throwPopup} from '@/pro/helpers/popup';

@Component({
  components: { SelectBox, ToolTip },
})
export default class UploadForm extends Vue {
  @Emit('open-image-upload-popup')
  private openImageUploadPopup(): boolean {
    return this.checkSelectedMall;
  }
  @Emit('download-sample-excel')
  private downloadSampleExcel(): boolean {
    return this.checkSelectedMall;
  }
  @Emit('post-excel-file')
  private postExcelFile(excelFile: File): ExcelUploadType {
    return { excelFile, resultPopup: this.openResultPopup, mallNo: this.mallNoSync };
  }

  @PropSync('mallNo', { required: true }) private mallNoSync: string;

  @Prop({ required: true }) private type!: string;
  @Prop({ required: false }) private checkBeforeUploadingExcel!: () => boolean;

  private mallList: Mall[] = [];
  private isOnlyOneMall = mall.isOnlyOneMall;
  private showHelpDetail = false;

  created() {
    this.setMall();
  }

  private setMall(): void {
    if (mall.isOnlyOneMall) {
      this.mallNoSync = mall.onlyOneMallNo.toString();
    }
    this.mallList = this.addDisableOptionPrimium(mall.mallsSortedByCreationDate);
  }

  private addDisableOptionPrimium(list) {
    return list.map(mall => ({mallNo: mall.mallNo, mallName: mall.mallName, disabled: mall.planType === 'PREMIUM'}));
  }

  private get checkSelectedMall(): boolean {
    return this.mallNoSync === '';
  }

  private onClickExcelUpload(): void {
    if (this.checkBeforeUploadingExcel && !this.checkBeforeUploadingExcel()) return;
    (this.$el.querySelector('#excelFile') as HTMLElement).click();
  }

  private uploadExcelFile({ target }: { target: HTMLInputElement }) {
    const excelFile = target.files[0];
    target.value = null;
    const isExelFile = validateFileNameExtension(excelFile, `PRO_PRODUCT_BULK_IMAGE_EXCEL_UPLOAD_FAILURE_MSG_${this.type}`);
    if (!isExelFile) return;
    this.postExcelFile(excelFile);
  }

  private openResultPopup(result: ResultPopupData) {
    throwPopup({
      name: 'UploadResult',
      data: {
        result,
        type: this.type,
      },
    });
  }
}
